/* eslint-disable no-tabs */
import { COMPANY_PROFILE_DEFAULT } from 'components/icons/constants';
import PropTypes from 'prop-types';

const OperatingCountryIcon = ({
    color = COMPANY_PROFILE_DEFAULT.color,
    size = COMPANY_PROFILE_DEFAULT.size
}) => (
    <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width={size}
        height={size}
        viewBox="0 0 70.865 70.867"
        enableBackground="new 0 0 70.865 70.867"
    >
        <g>
            <path
                fill={color}
                d="M58.626,12.242c-3.012-3.014-6.519-5.379-10.425-7.031c-4.045-1.71-8.34-2.577-12.769-2.577
		c-4.428,0-8.724,0.867-12.768,2.577c-3.907,1.652-7.415,4.018-10.426,7.031C9.226,15.253,6.86,18.76,5.208,22.666
		c-1.71,4.045-2.576,8.339-2.576,12.768c0,4.428,0.866,8.723,2.576,12.768c1.652,3.905,4.018,7.414,7.031,10.427
		c3.011,3.01,6.519,5.376,10.426,7.028c4.044,1.71,8.34,2.577,12.768,2.577c4.429,0,8.724-0.867,12.769-2.577
		c3.907-1.652,7.414-4.019,10.425-7.028c3.013-3.013,5.379-6.521,7.029-10.427c1.71-4.045,2.578-8.34,2.578-12.768
		c0-4.429-0.868-8.723-2.578-12.768C64.005,18.76,61.639,15.253,58.626,12.242z M35.432,66.291
		c-17.016,0-30.858-13.843-30.858-30.857c0-17.016,13.842-30.856,30.858-30.856s30.859,13.841,30.859,30.856
		C66.292,52.448,52.448,66.291,35.432,66.291z"
            />
            <path
                fill={color}
                d="M35.434,13.515C23.317,13.531,13.52,23.291,13.51,35.407C13.5,47.559,23.277,57.35,35.426,57.353
		c12.098,0.006,21.878-9.767,21.929-21.835C57.405,23.401,47.533,13.497,35.434,13.515z M48.992,20.845
		c0.08,0.073,0.124,0.312,0.067,0.378c-0.129,0.155-0.324,0.346-0.5,0.35c-0.279,0.011-0.576-0.088-0.845-0.194
		c-1.204-0.478-2.356-0.373-3.473,0.264c-0.073,0.042-0.153,0.078-0.229,0.114c-0.812,0.381-1.363,0.186-1.735-0.652
		c-0.049-0.11,0.016-0.343,0.109-0.434c0.908-0.864,1.833-1.711,2.812-2.615C46.492,18.756,47.802,19.718,48.992,20.845z
		M38.572,15.716c-0.223,0.608-0.343,1.172-0.628,1.633c-0.166,0.269-0.592,0.512-0.903,0.514c-0.239,0.003-0.585-0.345-0.703-0.615
		c-0.226-0.526-0.327-1.106-0.51-1.772C36.752,15.556,37.596,15.63,38.572,15.716z M18.478,24.923
		c2.613-4.075,6.182-6.925,10.79-8.45c0.08-0.028,0.162-0.05,0.284-0.085c0.598,1.589,1.219,3.117,1.738,4.68
		c0.176,0.531,0.127,1.146,0.125,1.722c0,0.354-0.25,0.545-0.613,0.571c-0.274,0.021-0.548,0.063-0.821,0.085
		c-0.79,0.068-1.542,0.268-2.132,0.814c-0.635,0.592-1.339,0.752-2.179,0.618c-1.058-0.168-2.055,0.104-2.979,0.617
		c-1.52,0.847-1.692,2.41-0.39,3.56c1.465,1.295,3.189,2.084,5.129,2.19c1.656,0.093,2.607,0.837,3.013,2.412
		c0.218,0.837,0.829,1.364,1.591,1.726c0.965,0.457,1.821,0.076,2.536-0.5c0.792-0.637,1.404-0.278,2.06,0.127
		c0.651,0.406,1.176,0.936,1.146,1.766c-0.009,0.253-0.188,0.558-0.383,0.734c-0.841,0.764-1.718,1.485-2.58,2.226
		c-0.209,0.179-0.412,0.365-0.611,0.555c-1.037,0.978-1.443,2.132-1.086,3.551c0.178,0.71,0.313,0.682-0.511,0.899
		c-1.293,0.34-1.814,1.324-2.024,2.538c-0.059,0.341-0.071,0.685-0.12,1.025c-0.037,0.271-0.054,0.557-0.154,0.807
		c-0.086,0.226-0.272,0.415-0.415,0.616c-0.181-0.191-0.444-0.358-0.52-0.586c-0.142-0.417-0.207-0.869-0.243-1.313
		c-0.087-1.044-0.456-1.968-1.093-2.795c-0.242-0.313-0.471-0.635-0.706-0.953c-0.351-0.48-0.492-1.013-0.434-1.605
		c0.03-0.308,0.032-0.619,0.059-0.929c0.106-1.26-0.249-2.396-1.172-3.236c-1.206-1.098-1.818-2.322-1.585-4.001
		c0.145-1.038-0.425-1.831-1.27-2.493c-1.2-0.944-2.328-1.982-3.452-3.019c-0.589-0.544-1-1.227-1.156-2.032
		c-0.01-0.052-0.019-0.109-0.048-0.146C17.777,25.982,18.128,25.469,18.478,24.923z M54.943,30.957
		c0.139,1.223,0.341,2.396,0.393,3.571c0.199,4.402-0.947,8.438-3.394,12.108c-0.257,0.387-0.483,0.389-0.84,0.202
		c-0.925-0.482-1.327-1.312-1.052-2.319c0.168-0.612,0.396-1.207,0.601-1.811c0.318-0.938,0.487-1.894,0.379-2.89
		c-0.171-1.551-1.093-2.475-2.487-2.983c-1.361-0.498-2.654-1.112-3.806-2.004c-0.332-0.255-0.453-0.577-0.376-0.995
		c0.214-1.173,0.618-2.257,1.474-3.122c0.642-0.654,1.409-0.896,2.307-0.596c0.375,0.125,0.767,0.216,1.124,0.378
		c1.702,0.78,3.482,0.682,5.274,0.515C54.622,31.004,54.706,30.988,54.943,30.957z M50.928,28.957
		c-0.689-0.218-1.362-0.485-2.054-0.692c-1.999-0.604-3.725-0.058-4.97,1.63c-0.973,1.315-1.553,2.804-1.556,4.456
		c-0.002,1.014,0.583,1.771,1.413,2.257c1.182,0.691,2.389,1.363,3.644,1.902c1.601,0.688,1.972,1.272,1.533,2.983
		c-0.138,0.531-0.344,1.046-0.524,1.565c-0.92,2.642-0.46,4.052,1.832,5.607c-4.863,5.994-14.987,9.133-23.909,4.51
		c-9.939-5.151-12.836-16.324-9.563-24.692c1.289,2.089,3.125,3.544,4.972,4.981c0.364,0.283,0.519,0.565,0.465,1.045
		c-0.206,1.794,0.23,3.383,1.642,4.607c0.938,0.813,1.293,1.794,1.082,3.039c-0.195,1.152,0.135,2.219,0.836,3.16
		c0.214,0.289,0.42,0.589,0.646,0.868c0.46,0.568,0.694,1.212,0.751,1.941c0.036,0.442,0.055,0.914,0.219,1.315
		c0.229,0.563,0.5,1.154,0.907,1.588c1.008,1.074,2.631,0.935,3.411-0.313c0.368-0.589,0.515-1.328,0.707-2.016
		c0.113-0.409,0.114-0.85,0.172-1.274c0.066-0.483,0.324-0.774,0.824-0.851c0.199-0.031,0.399-0.102,0.588-0.186
		c0.787-0.341,1.208-0.942,1.215-1.805c0.001-0.274,0.003-0.567-0.085-0.817c-0.361-1.021,0.019-1.748,0.809-2.383
		c0.885-0.713,1.731-1.471,2.595-2.208c1.498-1.284,1.726-3.046,0.523-4.624c-0.712-0.937-1.65-1.602-2.806-1.915
		c-1.042-0.282-1.963-0.027-2.818,0.606c-0.612,0.452-0.819,0.383-1.145-0.326c-0.135-0.297-0.248-0.604-0.366-0.909
		c-0.581-1.501-1.679-2.348-3.268-2.575c-0.664-0.096-1.333-0.165-1.987-0.313c-1.212-0.271-2.288-0.824-3.228-1.732
		c0.492-0.379,1.027-0.528,1.597-0.558c0.273-0.015,0.552,0.008,0.823,0.052c1.047,0.166,1.996-0.059,2.795-0.754
		c0.578-0.502,1.223-0.703,1.975-0.754c1.831-0.116,2.727-1.058,2.847-2.888c0.068-1.058-0.226-2.04-0.607-3.007
		c-0.458-1.168-0.907-2.336-1.4-3.605c0.73-0.104,1.37-0.203,2.01-0.266c0.096-0.008,0.259,0.15,0.306,0.267
		c0.16,0.397,0.311,0.802,0.41,1.217c0.209,0.873,0.534,1.674,1.264,2.247c1.353,1.063,3.412,0.576,4.262-1.054
		c0.337-0.647,0.539-1.366,0.835-2.146c0.818,0.274,1.666,0.559,2.642,0.884c-0.55,0.534-1.021,0.956-1.458,1.412
		c-0.415,0.434-0.824,0.883-1.187,1.36c-0.523,0.688-0.55,1.446-0.087,2.169c0.306,0.471,0.665,0.927,1.07,1.313
		c0.819,0.775,1.808,0.921,2.826,0.476c1.773-0.774,1.429-0.916,3.519-0.267c1.062,0.33,2.006,0.004,2.744-0.951
		c1.656,1.933,2.858,4.063,3.719,6.551C53.155,29.062,52.038,29.311,50.928,28.957z"
            />
        </g>
    </svg>
);

OperatingCountryIcon.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default OperatingCountryIcon;
